
    var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',_vm._g({attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16","viewBox":"0 0 16 16"}},_vm.$listeners),[_c('path',{attrs:{"d":"M12 11h1v1h-1zM12 9h1v1h-1z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M15 6h-5V2a1 1 0 0 0-1-1H1a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1ZM2 3h2v2H2Zm0 4h2v2H2Zm0 6v-2h2v2Zm6 0H6v-2h2Zm0-4H6V7h2Zm0-4H6V3h2Zm6 8h-4v-1h1v-1h-1v-1h1V9h-1V8h4Z"}})])}
var staticRenderFns = []

    export default {
      render: render,
    }
  